import { DatePipe } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRipple } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Realisation, RealisationHourtype } from 'src/app/classes/realisation';
import { CodaltComponent } from 'src/app/codalt.component';
import type { RealisationRow } from 'src/app/components/hour-control/hour-control.types';
import { GenericModule } from 'src/app/generic/generic.module';
import { IsTraveltimePipe } from 'src/app/pages/check-hours/is-traveltime.pipe';
import { IsWorktimePipe } from 'src/app/pages/check-hours/is-worktime.pipe';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog-service/confirm-dialog.service';
import { RealisationService } from 'src/app/services/realisation.service';

@Component({
    selector: 'app-realisation-row-prefix',
    imports: [
        DatePipe,
        GenericModule,
        IsTraveltimePipe,
        IsWorktimePipe,
        MatButtonModule,
        MatIconModule,
        MatRipple,
        MatTooltipModule,
    ],
    templateUrl: './realisation-row-prefix.component.html',
    styleUrl: './realisation-row-prefix.component.scss',
    host: {
        class: 'd-flex align-items-center',
    },
})
export class RealisationRowPrefixComponent extends CodaltComponent {
    readonly notEditable = input(false);
    readonly row = input.required<RealisationRow>();
    readonly pauseUpdated = output<Realisation[]>();

    readonly RealisationService = RealisationService;

    private readonly confirmDialog = inject(ConfirmDialogService);
    private readonly realisationService = inject(RealisationService);

    get hasTooManyRegisteredMinutes(): boolean {
        const currentRow = this.row();

        return !!currentRow.realisation.user_id && currentRow.userRegisteredMinutes > 720;
    }

    get isPauseEditable(): boolean {
        const realisation = this.row().realisation;

        return (
            !realisation.user?.overtime &&
            !!realisation.user_id &&
            [RealisationHourtype.worktime, RealisationHourtype.education].includes(realisation.hourtype)
        );
    }

    changePause(event: Event, userId: number): void {
        event.preventDefault();
        event.stopPropagation();

        this.confirmDialog
            .confirm({
                title: 'Pauzeduur aanpassen',
                text: '',
                confirm: null,
                cancel: 'Annuleren',
                options: [
                    { minutes: 60, name: '1 uur' },
                    { minutes: 45, name: '3 kwartier' },
                    { minutes: 30, name: 'Half uur' },
                    { minutes: 15, name: 'Kwartier' },
                    { minutes: 0, name: 'Geen' },
                ],
            })
            .then((data: { minutes: number }) => {
                if (data) {
                    this.subscriptions.add(
                        this.realisationService
                            .changePause(this.row().realisation.bookdate, data.minutes, userId)
                            .subscribe(response => this.pauseUpdated.emit(response.data.realisations))
                    );
                }
            });
    }
}
